import {gql, useLazyQuery} from "@apollo/client";

const GET_DATA = gql`
    query Stage($stageSlug: String!) {
        stage(stageSlug: $stageSlug) {
            id
            slug
            name
            scheduleType
            gamesMode
            qtyTeamsQualified
            qtyTeamsAdditional
            hasResults
            season{
                id
                name
                slug
                division{
                    organization{                        
                        fields{
                            id
                            name
                            description
                            sportFacility{
                                name
                            }
                        }                            
                    }
                }
            }
            teams
            groups{
                id
                name
                teams
            }
            playDays{
                id
                day
                fromTime
            }
            fields{
                id
                name
            }
            referees{
                id
                fullName
                rating
            }
            stageReferees{
                id
                fullName
                rating
            }
        }
}

`;

export default function GetStageData() {
    return useLazyQuery(GET_DATA);
};